<template>
    <div>
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar>
        <v-footer absolute class="grey lighten-2" style="bottom: -25px !important;">
            <div> &copy; {{year}} Climate-RX</div>
            <v-spacer></v-spacer>
            <div> 
                <!-- <v-dialog v-model="dialog" class="dialog" max-width="50%">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="grey lighten-2 mr-10" icon>
                            <v-icon>contact_support</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="white--text" style="background-color: #2b3990">Have an issue?</v-card-title>
                        <v-card-text>
                            <div class="mt-3">
                                We are always striving to build the best product and experience possible.
                                Please let us know of any issues that you may be experiencing. We will let you know when
                                the issue has been fixed.
                            </div>
                        </v-card-text>
                        <v-textarea
                            class="ma-4"
                            outlined
                            label="Description of issue"
                        ></v-textarea>
                        <v-card-actions class="pa-8">
                            <v-spacer></v-spacer>
                            <v-btn class="error ma-1" @click="send()">Submit</v-btn>
                            <v-btn text class="ma-1" color="blue darken-1" @click="close()">Cancel</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->
            </div>
            <zendesk/>
        </v-footer>
    </div>
</template>
<script>
// import { mapActions } from "vuex";
// import axios from 'axios';
// import moment from 'moment'
// const url = require("../client_config/config").url;
import zendesk from './Zendesk'

 export default {
    components: {
        zendesk
    },
     data: function() {
         return {
             dialog: false,
             text: "",
             msg: false,
             year: new Date().getFullYear()
         }
     },
     methods: {
         showAdd() {

         },
         close() {
            this.dialog = false;

        },
        send() {
            this.msg = true;
            this.text = "Your message has been sent";
            this.close()
        }
     }
 }
</script>
<style>
@media screen and (max-width: 480px){
    .v-dialog.dialog {
        max-width: "100%";
    }   
}

</style>